import * as React from 'react';
import { IImageStatusType } from '../types/types';
import MultiImageDropZone from './../../../../share/components/MultiImageDropZone/MultiImageDropZone';

export interface IMiscellaneousFormProps {
  setValue: (path: string, value: any) => void;
  ius: IImageStatusType | undefined;
  images?: string[];
  disabled: boolean;
};

export interface IMiscellaneousFormState {
  currentArray: any[];
};

export class MiscellaneousForm extends React.Component<IMiscellaneousFormProps, IMiscellaneousFormState> {
  constructor(props: IMiscellaneousFormProps) {
    super(props);

    this.state = {
      currentArray: [],
    };
  }
  public render() {
    return (
      <div className={"margin-forms-multi"}>
        <MultiImageDropZone {...this.imageHandler()}/>
      </div>
    );
  }

  public imageHandler() {
    const { ius } = this.props;
    const status = ius && this.getStatus(ius);
    return {
      onChange: (base64: string[]) => this.props.setValue(`caseInfo.miscellaneous`, base64),
      loading: this.props.disabled,
      status,
      images: this.props.images
    }
  }

  public getStatus(ius) {    
    if(Object.keys(ius).length > 0) {
      const iuskeys = Object.keys(ius);
      const statArr:any[] = [];
      iuskeys.forEach(key => statArr.push(ius[key].status))
      const result = statArr.indexOf('UPLOADING') !== -1 ? 'UPLOADING' :  statArr.indexOf('FAILED') !== -1 ? 'FAILED' : 'SUCCESS'
      return result
    }
    return undefined;
  } 
}

export default MiscellaneousForm;



// WEBPACK FOOTER //
// ./src/modules/Case/Add/components/MiscellaneousForm.tsx